<div class="paginator__pagination">
  <ion-button
    class="button button--circle button--circle--sm"
    (click)="previousPage()"
    [disabled]="page === 1"
    ><i class="fa-light fa-left"></i
  ></ion-button>
  <div class="paginator__pages">
    <ng-container *ngIf="firstPage">
      <div class="paginator__extreme-pages">
        <ion-button
          class="button button--circle button--circle--sm button--outline"
          (click)="goToPage(1)"
          >1</ion-button
        >
        <span *ngIf="showFirstDots">...</span>
      </div>
    </ng-container>
    <ng-container *ngFor="let pageToShow of pageNumbers">
      <ion-button
        class="button button--circle button--circle--sm button--outline"
        (click)="goToPage(pageToShow)"
        [disabled]="page === pageToShow"
        [ngClass]="{'button--active': page === pageToShow}"
        >{{ pageToShow }}</ion-button
      >
    </ng-container>
    <ng-container *ngIf="lastPage">
      <div class="paginator__extreme-pages">
        <span *ngIf="showLastsDots">...</span>
        <ion-button
          class="button button--circle button--circle--sm button--outline"
          (click)="goToPage(totalPages)"
          >{{ totalPages }}</ion-button
        >
      </div>
    </ng-container>
  </div>
  <ion-button
    class="button button--circle button--circle--sm"
    (click)="nextPage()"
    [disabled]="page === totalPages"
    ><i class="fa-light fa-right"></i
  ></ion-button>
  <div> </div>
</div>
